import { UnderwriterSearchRequestQuery, UnderwriterSearchResponse } from '@lio/api-types';
import { underwriterQueryKey } from '@services/underwriter/keys';
import { searchUnderwriterQueryParams } from '@services/underwriter/underwriter.helpers';

import { useInfiniteQuery } from '@tanstack/react-query';
import { useClient } from '@utils/api-client';

export const useSearchPaginatedUnderwriters = (params?: UnderwriterSearchRequestQuery & { enabled?: boolean }) => {
  const client = useClient();
  const query = searchUnderwriterQueryParams(params ?? {});
  const result = useInfiniteQuery<UnderwriterSearchResponse, Error>({
    queryKey: underwriterQueryKey.searchWithParams({ ...params }),
    queryFn: ({ pageParam }) =>
      client.get(`underwriter?${query}&pageOffset=${pageParam}`).json<UnderwriterSearchResponse>(),
    initialPageParam: 0,
    staleTime: 2000,
    enabled: params?.enabled ?? true,
    placeholderData: (previousData) => previousData,
    refetchOnWindowFocus: false,
    getNextPageParam: (lastPage, allPages) => {
      if (!lastPage?.pagination) return undefined;
      if (!lastPage.pagination.pageLimit) return undefined;
      if (!lastPage.pagination.total) return undefined;
      const { total, pageLimit } = lastPage.pagination;
      const fetchedPageCount = allPages.length;
      const nextPageOffsetValue = fetchedPageCount * pageLimit;
      if (nextPageOffsetValue > total) return undefined;
      return nextPageOffsetValue;
    },
  });
  return { ...result, underwriters: result.data };
};
